import React from 'react';

const MetroInfoPanel = ({ darkMode, isMobile = false }) => {
  const metroLines = [
    { id: 'M1a', name: 'Yenikapı-Atatürk Havalimanı Metro Hattı', color: '#e61e26' },
    { id: 'M1b', name: 'Yenikapı-Kirazlı Metro Hattı', color: '#e61e26' },
    { id: 'M2', name: 'Yenikapı-Hacıosman Metro Hattı', color: '#069641' },
    { id: 'M3', name: 'Kirazlı-Olimpiyat-Başakşehir Metro Hattı', color: '#15abe3' },
    { id: 'M4', name: 'Kadıköy-Tavşantepe Metro Hattı', color: '#dd1479' },
    { id: 'M5', name: 'Üsküdar-Çekmeköy Metro Hattı', color: '#752558' },
    { id: 'M6', name: 'Levent-Boğaziçi Ü./Hisaüstü Metro Hattı', color: '#966d4e' },
    { id: 'T1', name: 'Kabataş-Bağcılar Tramvay Hattı', color: '#1472b9' },
    { id: 'T2', name: 'Taksim-Tünel Nostaljik Tramvay', color: '#8e9d99' },
    { id: 'T3', name: 'Kadıköy-Moda Tramvay Hattı', color: '#b27551' },
    { id: 'T4', name: 'Topkapı-Mescid-i Selam Tramvay Hattı', color: '#e07834' }
  ];

  return (
    <div 
      className="metro-info-panel" 
      style={{ 
        backgroundColor: darkMode ? 'rgba(40, 40, 40, 0.9)' : 'rgba(255, 255, 255, 0.9)',
        padding: isMobile ? '8px' : '12px',
        maxHeight: isMobile ? '40vh' : '80vh',
        overflowY: 'auto'
      }}
    >
      <h4 style={{ marginTop: 0, marginBottom: isMobile ? 6 : 8, fontSize: isMobile ? 12 : 14 }}>
        Metro Hatları
      </h4>
      <div>
        {metroLines.map(line => (
          <div 
            key={line.id} 
            className="metro-line"
            style={{
              marginBottom: isMobile ? '4px' : '6px',
              fontSize: isMobile ? '11px' : '12px'
            }}
          >
            <div 
              className="metro-line-badge" 
              style={{ 
                backgroundColor: line.color,
                fontSize: isMobile ? '10px' : '11px',
                padding: isMobile ? '2px 6px' : '3px 8px',
                minWidth: isMobile ? '35px' : '40px'
              }}
            >
              {line.id}
            </div>
            <span style={{ 
              fontSize: isMobile ? '11px' : '12px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: isMobile ? 'nowrap' : 'normal'
            }}>
              {line.name}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MetroInfoPanel;
